<template>
  <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="serial" :selection="selection" :before-reset-search="beforeResetSearch" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
    <template v-slot:baseForm>
      <el-col :span="colSpan">
        <el-form-item :label="$t('goodsPage.skuName')" prop="skuName">
          <BjInput v-model="queryParams.skuName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('goodsPage.skuName')" clearable @keyup.enter.native="handleQuery" />
        </el-form-item>
      </el-col>
      <el-col :span="colSpan">
        <el-form-item :label="$t('goodsPage.skuCode')" prop="skuCode">
          <BjInput v-model="queryParams.skuCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('goodsPage.skuCode')" clearable @keyup.enter.native="handleQuery" />
        </el-form-item>
      </el-col>
      <el-col :span="colSpan">
        <el-form-item :label="$t('table.statusText')">
          <BjSelectLov v-model="tempStatus" :option-list="GOODS_AUDIT_STATUS_STRING_LIST" :placeholder="$t('table.statusText')" multiple />
        </el-form-item>
      </el-col>
      <el-col :span="colSpan">
        <BjSelectLov v-model="queryParams.cusId" :option-list="customerList" :placeholder="$t('customerNameText')" />
      </el-col>

    </template>
    <template v-slot:tableOperation>
      <el-col>
        <el-button type="primary" @click="onAuditList">{{ $t('goodsPage.review') }}</el-button>
        <el-button type="primary" @click="onCancelList">{{ $t('goodsPage.rejection') }}</el-button>
      </el-col>
    </template>
    <template v-slot:tableColumn>
      <template v-for="(col, index) in dropCols">
        <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item" :show-overflow-tooltip="col.prop !== 'bjTableAction'">
          <template slot-scope="scope">
            <template v-if="false" />
            <template v-else-if="col.prop == 'cusId'">{{ customerList.bjGet(scope.row.cusId) }}</template>
            <template v-else-if="col.prop === 'materialMainImages'">
              <BjViewUrl height="80px" :url="(scope.row[col.prop] || [])[0]" preview />
            </template>
            <el-tag v-else-if="col.prop === 'status'">
              {{ $t(GOODS_AUDIT_STATUS_LIST.bjGet(scope.row[col.prop])) }}
            </el-tag>
            <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
          <template slot-scope="props">
            <el-button v-if="setFlag == GOODS_COMBO_TYPES.ORDINARY" v-permission:BusinessGoodsAuditSkuOrdinaryCSGView type="text" @click="onLook(props.row)">{{ $t('viewText') }}</el-button>
            <el-button v-else v-permission:BusinessGoodsAuditSkuPackageCSGView type="text" @click="onLook(props.row)">{{ $t('viewText') }}</el-button>
            <el-button v-if="(props.row.status == 2 || props.row.status == 4)&&setFlag == GOODS_COMBO_TYPES.ORDINARY" v-permission:BusinessGoodsAuditSkuOrdinaryCSGAudit type="text" @click="onAudit(props.row)">{{ $t('table.auditText') }}</el-button>
            <el-button v-if="(props.row.status == 2 || props.row.status == 4)&&setFlag == GOODS_COMBO_TYPES.PACKAGE" v-permission:BusinessGoodsAuditSkuPackageCSGAudit type="text" @click="onAudit(props.row)">{{ $t('table.auditText') }}</el-button>
          </template>
        </el-table-column>
      </template>
    </template>
  </BjPage>
</template>

<script>
import { goodsApi } from '@/api';
import pageMiXin from '@/utils/page-mixin.js';
import BjSelectCustomer from '@/components/BjSelectCustomer/index.vue';
import { GOODS_TYPE_LIST, GOODS_AUDIT_STATUS_LIST, GOODS_COMBO_TYPES, STATUS_YES_TRUE, ITEM_TYPE_CHOOSE } from '@/utils/constants';
const DEFAULT_STATUS = [...GOODS_AUDIT_STATUS_LIST[0].value];
const GOODS_AUDIT_STATUS_STRING_LIST = [
  ...GOODS_AUDIT_STATUS_LIST.map(e => {
    return {
      ...e,
      value: e.value + '',
    };
  }),
];
const DEFAULT_STATUS_STRING = [GOODS_AUDIT_STATUS_STRING_LIST[0].value];
export default {
  name: 'BusinessGoodsAuditSkuPageOrdinaryPackage',
  components: { BjSelectCustomer },
  mixins: [pageMiXin],
  props: {
    setFlag: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      colSpan: 4,
      selection: true,
      GOODS_TYPE_LIST,
      STATUS_YES_TRUE,
      ITEM_TYPE_CHOOSE,
      GOODS_AUDIT_STATUS_LIST,
      GOODS_AUDIT_STATUS_STRING_LIST,
      queryApi: goodsApi.getSkuAuditList, // settingApi.getStockProcess,
      GOODS_COMBO_TYPES,
      // 查询参数
      tempStatus: DEFAULT_STATUS_STRING,
      queryParams: {
        cusId: null,
        skuCode: null,
        spuName: null,
        dimensionsChecked: null,
        itemType: null,
        status: DEFAULT_STATUS,
        setFlag: this.setFlag,
      },
      srcList: [],
      labelsVersion: 11,
      labelList: [
        { label: 'goodsPage.skuCode', prop: 'skuCode', isCheck: true, disabled: false, width: 180 },
        { label: 'billingPage.CustomerName', prop: 'cusId', isCheck: true, disabled: false, width: 150 },
        { label: 'table.statusText', prop: 'status', isCheck: true, disabled: false, width: 180 },
        { label: 'goodsSku.detail.Barcode', prop: 'barCode', isCheck: true, disabled: false, width: 150 },
        { label: 'goodsPage.skuName', prop: 'skuName', isCheck: true, disabled: false, width: 180 },
        { label: 'BjDialogListConfig.Producttype', prop: 'itemType', isCheck: true, disabled: false, width: 180 },
        { label: 'goodsSku.detail.length', prop: 'length', isCheck: true, disabled: false, width: 150 },
        { label: 'goodsSku.detail.width', prop: 'width', isCheck: true, disabled: false, width: 150 },
        { label: 'goodsSku.detail.height', prop: 'height', isCheck: true, disabled: false, width: 150 },
        { label: 'goodsSku.detail.weight', prop: 'weight', isCheck: true, disabled: false, width: 150 },
        { label: 'goodsAudit.page.Approvaltime', prop: 'auditCommitDate', isCheck: true, disabled: false, width: 180 },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 150 },
      ],
    };
  },
  computed: {},
  watch: {
    tempStatus(v, o) {
      if (Array.isArray(v) && v.length) {
        const TEMP = [];
        v.forEach(e => {
          e = e.split(',');
          TEMP.push(...e);
        });
        this.queryParams.status = TEMP.map(e => Number(e));
      } else {
        this.queryParams.status = [];
        GOODS_AUDIT_STATUS_LIST.map(e => e.value).forEach(e => {
          this.queryParams.status.push(...e);
        });
      }
    },
  },
  mounted() {},
  methods: {
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.tempStatus = DEFAULT_STATUS_STRING;
      this.queryParams.cusId = null;
      return new Promise(resolve => {
        resolve();
      });
    },
    /** 查 看 */
    onLook(row) {
      const { status, id } = row;
      const NAME =
        this.setFlag == GOODS_COMBO_TYPES.PACKAGE
          ? 'BusinessGoodsAuditSkuPackageCSGView'
          : 'BusinessGoodsAuditSkuOrdinaryCSGView';
      this.$router.push({
        name: NAME,
        query: {
          id,
          status,
        },
      });
    },
    /** 审 核 */
    onAudit(row) {
      const { status, id } = row;
      const NAME =
        this.setFlag == GOODS_COMBO_TYPES.PACKAGE
          ? 'BusinessGoodsAuditSkuPackageCSGAudit'
          : 'BusinessGoodsAuditSkuOrdinaryCSGAudit';
      this.$router.push({
        name: NAME,
        query: {
          id,
          status,
        },
      });
    },
    // 批量审核
    async onAuditList() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
        return;
      }
      if (this.selectedRows.length > 200) {
        this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning1'));
        return;
      }
      this.$confirm(this.$t('InternalSalesOrderDetails.want')).then(() => {
          let promise = Promise.resolve();
          this.selectedRows.forEach((item) => {
            promise = promise.then(() => {
              return new Promise(resolve => {
                goodsApi.skuAudit({ auditIdea: null, flag: true, id: item.id }).then(res => {
                  if (res.failed === false) {
                    resolve();
                  }
                });
              });
            });
          });
          return promise.then(() => {
            this.$message.success(this.$t('toast.operationSuccessText'));
            this.reFresh();
          });
      });
    },
    // 循环批量审批
    // onAuditList() {
    //   if (!this.selectedRows.length) { this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning')); return; }
    //   this.$confirm(this.$t('InternalSalesOrderDetails.want')).then(() => {
    //     let idList =[]
    //     this.selectedRows.forEach((item) => {
    //       idList.push({auditIdea: null, flag: true, id: item.id})
    //     });
    //     // console.log(idList,'批量审核');
    //     goodsApi.skuBatchAudit(idList).then(res => {
    //       console.log(res,'批量审核');
    //       this.$message.success(this.$t('toast.operationSuccessText'));
    //       this.reFresh();
    //     });
    //   });
    // },
    // 批量驳回
    async onCancelList() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
        return;
      }
      this.$confirm(this.$t('InternalSalesOrderDetails.want')).then(() => {
          let promise = Promise.resolve();
          this.selectedRows.forEach((item) => {
            promise = promise.then(() => {
              return new Promise(resolve => {
                goodsApi.skuAudit({ auditIdea: null, flag: false, id: item.id }).then(res => {
                  if (res.failed === false) {
                    resolve();
                  }
                });
              });
            });
          });
          return promise.then(() => {
            this.$message.success(this.$t('toast.operationSuccessText'));
            this.reFresh();
          });
      });
    },
  },
};
</script>
